import { DialogActions as MuiDialogActions, DialogTitle, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { smallerInputsAndDropdowns } from "../../../utils/styles-utils/smallerInputsAndDropdowns/smaller-inputs-and-dropdowns";

export const Title = styled(DialogTitle)({
  "& p.MuiTypography-root:first-of-type": {
    fontWeight: "bold",
  },
  "& p.MuiTypography-root:nth-of-type(2)": {
    color: "grey",
  },
});

export const TransactionScreen = styled(Grid)({
  minWidth: 450,
  width: "100%",
  padding: "0 20px",
  gap: "100px",
  display: "flex",
  flexDirection: "row",
  ...smallerInputsAndDropdowns,
});

export const Actions = styled(MuiDialogActions)({
  display: "flex",
  justifyContent: "space-between",
  padding: "15px 20px",

  "& button": {
    margin: "0 5px",
  },
});

export const DialogsTitle = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});
